import { coerce, lt } from 'semver';

/**
 * Compares loose version strings such as an OS version ("17.5", "14") or an
 * Android WebView version ("119.0.6045.193"), which are not valid semver.
 * Returns false when either version can't be parsed, so a missing or invalid
 * threshold never triggers a warning.
 */
export function isBelowVersion(
  version: string | null | undefined,
  threshold: string | null | undefined,
): boolean {
  const parsedVersion = coerce(version);
  const parsedThreshold = coerce(threshold);

  return (
    !!parsedVersion && !!parsedThreshold && lt(parsedVersion, parsedThreshold)
  );
}
